import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppConstants } from 'src/app/common/app.constants';
import { LoginService } from './login.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  token: string = '';
  errorMessage: string = '';

  constructor(
    private builder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private snackBarService: SnackBarService
  ) {
    sessionStorage.removeItem(AppConstants.SESSION_VAR_USER);
    sessionStorage.removeItem(AppConstants.SESSION_VAR_TOKEN);
    this.loginForm = this.builder.group({
      employee_id: this.builder.control('', Validators.required)
    });
  }

  ngOnInit(): void {
    this.authenticate();
    this.route.queryParams.subscribe(params => {
      let t = params['t'];
      if (!t) {
        const returnUrl = params['returnUrl'];
        if (returnUrl) {
          try {
            const decodedUrl = decodeURIComponent(returnUrl);
            const match = decodedUrl.match(/[?&]t=([^&]+)/);
            if (match) {
              t = match[1];
            }
          } catch (e) {}
        }
      }
      
      if (t) {
        sessionStorage.setItem('roster_token', t);
      } else {
        t = sessionStorage.getItem('roster_token') || '';
      }
      
      this.token = t || '';
      if (!this.token) {
        this.errorMessage = 'Invalid or missing access token. Please check your email link.';
      }
    });
  }

  authenticate() {
    let authData = {
      user_name: environment.userId,
      password: environment.password,
      apikey: environment.appKey
    };

    this.loginService.authenticate(authData).subscribe(
      response => {
        if (response.status == 'SUCCESS') {
          let token = response.token;
          sessionStorage.setItem(AppConstants.SESSION_VAR_TOKEN, token);
        } else {
          let snackBarData: SnackBarData = {
            title: "Failed",
            message: response.message,
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }

  proceedLogin() {
    if (this.loginForm.invalid) {
      return;
    }

    if (!this.token) {
      let snackBarData: SnackBarData = {
        title: "Login Failed",
        message: "No valid token found in link.",
        type: 'error'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }

    const employeeId = this.loginForm.value.employee_id;

    this.loginService.employeeLogin(employeeId, this.token).subscribe(
      response => {
        if (response.status === 'SUCCESS') {
          sessionStorage.setItem(AppConstants.SESSION_VAR_USER, JSON.stringify(response.data));
          sessionStorage.setItem(AppConstants.SESSION_VAR_TOKEN, response.token);
          const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/roster';
          this.router.navigateByUrl(returnUrl);
        } else {
          let snackBarData: SnackBarData = {
            title: "Login Failed",
            message: response.message || 'Access denied.',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error => {
        let snackBarData: SnackBarData = {
          title: "Error",
          message: "An error occurred during login. Please try again.",
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    );
  }
}
